import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import VideoLessonsScreen from "./components/VideoLessonsScreen";
import StudyGuidesScreen from "./components/StudyGuidesScreen";
import DiagnosticTestScreen from "./components/DiagnosticTestScreen";
import ListeningTest from "./components/Tests/ListeningTest";
import ReadingTest from "./components/Tests/ReadingTest";
import SpeakingTest from "./components/Tests/SpeakingTest";
import WritingTest from "./components/Tests/WritingTest";
import Listening from "./pages/Tests/Listening";

const Home = lazy(() => import("./pages/Home/Home"));
const Login = lazy(() => import("./pages/auth/login/Login"));
const Register = lazy(() => import("./pages/auth/register/Register"));

const Routers = () => {
  return (
    <Suspense>
      <AuthProvider>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/register" element={<Register />} />
          <Route exact path="/video-lessons" element={<VideoLessonsScreen />} />
          <Route exact path="/study-guides" element={<StudyGuidesScreen />} />
          <Route
            exact
            path="/diagnostic-test"
            element={<DiagnosticTestScreen />}
          />
          <Route exact path="/listening-test" element={<ListeningTest />} />
          <Route exact path="/reading-test" element={<ReadingTest />} />
          <Route exact path="/speaking-test" element={<SpeakingTest />} />
          <Route exact path="/writing-test" element={<WritingTest />} />
          <Route exact path="/listening" element={<Listening />} />
        </Routes>
      </AuthProvider>
    </Suspense>
  );
};

export default Routers;
